import type { UserRole } from '@/lib/types';

export function roleHomePath(role: UserRole): string {
  switch (role) {
    case 'admin':
      return '/admin';
    case 'doctor':
      return '/doctor';
    default:
      return '/';
  }
}

export function hasAccessToken(): boolean {
  return Boolean(localStorage.getItem('access_token'));
}

export function isProtectedPath(pathname: string): boolean {
  return pathname.startsWith('/admin') || pathname.startsWith('/doctor');
}
